import { type User } from '@/generated/graphql';
import { defineStore } from 'pinia';

type ResourcePlanningStoreType = {
	selectedUserIds: Set<User['id']>;
	isMembersListCollapsed: boolean;
};

export const useResourcePlanningStore = defineStore('resourcePlanning', {
	state: (): ResourcePlanningStoreType => ({
		selectedUserIds: new Set(),
		isMembersListCollapsed: false,
	}),
	actions: {
		addSelectedUserIds(ids: Array<User['id']>) {
			ids.forEach((id) => {
				this.selectedUserIds.add(id);
			});
		},
		removeSelectedUserId(id: User['id']) {
			this.selectedUserIds.delete(id);
		},
		toggleIsProjectCollapsed() {
			this.isMembersListCollapsed = !this.isMembersListCollapsed;
		},
	},
});
